import Storage from "good-storage";
import Config from "@/config/index.js";

export function getToken() {
  return Storage.get(Config.tokenKey);
}

export function setToken(token) {
  return Storage.set(Config.tokenKey, token);
}

export function removeToken() {
  return Storage.remove(Config.tokenKey);
}

export function isLogin() {
  return (getToken() || "").length > 5;
}

export function getUserInfo(key = null) {
  let userInfo = Storage.get(Config.userInfoKey) || {};
  if (key) return userInfo.hasOwnProperty(key) ? userInfo[key] : null;
  return userInfo;
}

export function setUserInfo(user) {
  Storage.set(Config.userInfoKey, user);
  return user;
}

export function removeUserInfo() {
  return Storage.remove(Config.userInfoKey);
}

// 手机号打码显示，如 138****1234
export function phoneMask(phone) {
  if (!phone || phone.length !== 11) return phone;
  return phone.substring(0, 3) + "****" + phone.substring(7);
}

// 设备类型判断，照抄campaign-voting-star的实现，去掉了isClient(内嵌App)那个分支，
// 因为咱们这个H5是独立浏览器打开的，不会跑在App的webview里
export function deviceInfo() {
  let userAgentInfo = navigator.userAgent;
  let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
  let flag = "PC";
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = "PHONE";
      break;
    }
  }
  return flag;
}
